import { Box, Typography } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { ReportComment } from "../ReportComment";
import { getCriteriaCommentsHistory, saveCriteriaComments, updateOnSiteCriteriaComments } from "../../api/evaluation";
import { useDispatch, useSelector } from "react-redux";
import { resetCriteriaComment, resetSelectedCommentPhase, resetSelectedOnSiteCriteria, setCommentContent, setCriteriaComment, setCriteriaCommentsHistory, setOnSiteCriteriaComments, setOnSiteSelectedCommentBoxTab, setSelectedCommentPhase } from "../../redux/reducers/evaluation";
import { useTranslation } from "react-i18next";
import { setSnackBarData } from "../../redux/reducers/common";

const OnSiteCommentBoxWrapper = () => {
    
    const dispatch = useDispatch();
    const clubDetails = useSelector((state:any) => state.clubDetails);
    const currentSection = useSelector((state:any) => state.evaluation.currentEvaluationTab);
    const onSiteCriteriaComments = useSelector((state:any) => state.evaluation.onSiteCriteriaComments);
    const criteriaComments = useSelector((state:any) => state.evaluation.criteriaComment);
    const selectedOnSiteCriteria = useSelector((state:any) => state.evaluation.selectedOnSiteCriteria);
    const commentContent = useSelector((state:any) => state.evaluation.commentContent);
    const [isEdited, setIsEdited] = useState(false);
    const criteriaCommentsHistory = useSelector((state:any) => state.evaluation.criteriaCommentsHistory);
    const [t] = useTranslation();
    const isAdmin = useSelector((state:any) => state.common.isAdmin);
    const selectedTab:any = useSelector((state:any) => state.evaluation.onSiteSelectedCommentBoxTab);


    useEffect(() => {
        (!selectedOnSiteCriteria || Object.keys(selectedOnSiteCriteria)?.length == 0) && dispatch(resetSelectedCommentPhase());
        (!selectedOnSiteCriteria || Object.keys(selectedOnSiteCriteria)?.length == 0) && dispatch(resetCriteriaComment());
        (!selectedOnSiteCriteria || Object.keys(selectedOnSiteCriteria)?.length == 0) && dispatch(resetSelectedOnSiteCriteria());
    }, [currentSection])

    useEffect(() => {
        if (selectedOnSiteCriteria) {
            const currentPhase:any = t('ON_SITE');
            dispatch(setSelectedCommentPhase(currentPhase));
        }
    }, [clubDetails]);

    const fetchKey:any = (value:any) => {
        switch(value) {
            case t('SELF_ASSESSMENT'):
            case 'SELF_ASSESSMENT':
                return 'selfAssessmentComment';
            case t('OFF_SITE'):
            case 'OFF_SITE':
                return 'offSiteComment';
            case t('ON_SITE'):
            case 'ON_SITE':
                return 'comment';
            // case t('INTERIM_REPORT'):
            // case 'INTERIM_REPORT':
            //     return 'interimReportComment';
            case t('REPORTS'):
            case 'REPORTS':
                return 'finalReportComment';
        }
    }
    const fetchCommentHistory:any = (value:any) => {
        switch(value) {
            case t('SELF_ASSESSMENT'):
            case 'SELF_ASSESSMENT':
                return criteriaCommentsHistory?.selfAssessmentCommentHistory || [];
            case t('OFF_SITE'):
            case 'OFF_SITE':
                return criteriaCommentsHistory?.offSiteCommentHistory || [];
            case t('REPORTS'):
            case 'REPORTS':
                return criteriaCommentsHistory?.reportsCommentHistory || [];
        }
    }

    const fetchCriteriaCommentsHistory = () => {
        getCriteriaCommentsHistory({ clubId: clubDetails.id, criteriaId: selectedOnSiteCriteria.id})
        .then((historyRes:any) => {
            dispatch(setCriteriaCommentsHistory(historyRes));
        })
    }
    const manageChange = (value:any, currentOnsiteData:any) => {
        if (selectedTab == t('ON_SITE')) {
            const tempArr:any = onSiteCriteriaComments.map((x:any) => {
                if (x.sessionId == currentOnsiteData.sessionId) {
                    dispatch(setCommentContent({ ...x, comment: value }));
                    return { ...x, comment: value }
                } return x;
            });
            dispatch(setOnSiteCriteriaComments(tempArr));
        } else {
            dispatch(setCriteriaComment({...criteriaComments, [fetchKey(selectedTab)]: value}));
        }
        setIsEdited(true);
    }

    const manageSaveComment = async (currentOnsiteData:any) => {
            if (isEdited) {
                if(selectedTab == t('ON_SITE')) {
                    // const response = await updateOnSiteCriteriaComments({data: currentOnsiteData});
                    const tempArr:any = [...onSiteCriteriaComments, currentOnsiteData];
                    dispatch(setOnSiteCriteriaComments(tempArr));
                } else {
                    saveCriteriaComments({id: criteriaComments?.id ? criteriaComments.id : 0,
                            data: {...criteriaComments,
                            criteriaId: selectedOnSiteCriteria?.id, clubId: clubDetails.id,
                            }}).then((res:any) => {
                            dispatch(setCriteriaComment(res || Object));
                            fetchCriteriaCommentsHistory();
                            });
                }   
            }
            // updateCriteriaMetadata();
    }

    const manageDeleteComment = async (commentOf:any, commentData:any) => {
        if (commentOf == t('ON_SITE')) {
            // const tempArr:any = onSiteCriteriaComments.map((x:any) => {
            //     if (x.sessionId == commentContent?.sessionId) {
            //         return { ...x, comment: '', commentUpdatedUsers: commentContent?.commentUpdatedUsers.length > 0 ? commentContent?.commentUpdatedUsers : [] }
            //     } return {x, commentUpdatedUsers: commentContent?.commentUpdatedUsers.length > 0 ? commentContent?.commentUpdatedUsers : [] };
            // });
            const contentToDelete = {...commentData, comment: ''};
            await updateOnSiteCriteriaComments({data: contentToDelete}).then((res:any) => {
                dispatch(setOnSiteCriteriaComments(res));
                const warningData:any = {isOpen: true, severity: 'success', message: t('UPDATED_CRITERIA_COMMENT_SUCCESSFULLY')};
                dispatch(setSnackBarData(warningData));
            });
        } else {
            const updatedComments = {...criteriaComments, [fetchKey(commentOf)]: ''};
            saveCriteriaComments({id: criteriaComments?.id ? criteriaComments.id : 0,
                    data: {...updatedComments,
                    criteriaId: criteriaComments?.id, clubId: clubDetails.id,
                    }}).then(() => {
                        dispatch(setCriteriaComment(updatedComments));
                        const warningData:any = {isOpen: true, severity: 'success', message: t('UPDATED_CRITERIA_COMMENT_SUCCESSFULLY')};
                        dispatch(setSnackBarData(warningData));
                    });
        }
    }

    const manageTabSwitch = (newTab:any) => {
        dispatch(setOnSiteSelectedCommentBoxTab(newTab));
    }

    useEffect(() => {
        if (selectedTab ==null || selectedTab == undefined) {
            const tempTab:any = t('ON_SITE');
            dispatch(setOnSiteSelectedCommentBoxTab(tempTab));
        }
    }, [selectedTab]);
    

    return (
        <>
            {/* <Box sx={{ width: '30%' }}>
                <CommentsOverviewBox 
                parentComponent={'jlEval'}
                tabs={tabs}
                selectedTab={selectedTab}
                handleTabChange={handleTabChange}
                currentTab={currentSection}
                onSiteCriteriaComments={onSiteCriteriaComments}
                criteriaComments={criteriaComments}
                selectedCriteria={selectedOnSiteCriteria}
                selectedCommentPhase={selectedCommentPhase}
                deleteComment={manageDeleteComment} />
            </Box> */}
            <Box sx={{ width: '100%' }}>
                {
                    selectedOnSiteCriteria && Object.keys(selectedOnSiteCriteria).length > 0 ?
                    <ReportComment 
                    manageChange={manageChange}
                    manageSaveComment={manageSaveComment}
                    tabList={[t('SELF_ASSESSMENT'), t('OFF_SITE'), t('ON_SITE'), t('REPORTS')]}
                    selectedTab={selectedTab}
                    deleteComment={manageDeleteComment}
                    onSiteCriteriaComments={onSiteCriteriaComments}
                    criteriaComments={criteriaComments}
                    isDeletable={isAdmin && selectedTab == t('SELF_ASSESSMENT') ? false : true}
                    handleTabSwitch={manageTabSwitch}
                    commentHistory={fetchCommentHistory(selectedTab)} /> :
                    <Typography className="mb20 fs20 fw800">{t('SELECTET_ANY_CRITERIA')}</Typography>
                }
            </Box>
        </>
    )
}

export default OnSiteCommentBoxWrapper